import type { DataItem } from '@pn/core/domain/data';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type FormationsOverviewInitialState = {
  isFetching: boolean;
  isError: boolean;
  stats: DataItem[];
  shouldLoadStats: boolean;
};

const initialState: FormationsOverviewInitialState = {
  isFetching: false,
  isError: false,
  stats: [],
  shouldLoadStats: true,
};

const createFormationsOverviewSlice = (sliceName: string) =>
  createSlice({
    name: sliceName,
    initialState,
    reducers: {
      request: (state) => {
        state.isFetching = true;
        state.isError = false;
        state.shouldLoadStats = false;
      },
      receive: (state, { payload }: PayloadAction<DataItem[]>) => {
        state.stats = payload;
        state.isFetching = false;
      },
      error: (state) => {
        state.isFetching = false;
        state.isError = true;
      },
      reset: (state) => {
        state.isFetching = false;
        state.isError = false;
        state.shouldLoadStats = true;
      },
    },
  });

export const formationsOverviewSlice =
  createFormationsOverviewSlice('formationsOverview');
